import React, { useState, useMemo } from 'react';
import Button from '@/components/Button';

export default function NewsModal({ news, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % news.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + news.length) % news.length);
  };

  const linkedContent = useMemo(() => {
    const phrase = "Beca útiles escolares 2026";
    const text = news[currentIndex]?.content || "";
    const idx = text.indexOf(phrase);
    if (idx === -1) return text;
    return (
      <>
        {text.slice(0, idx)}
        <a href="/informaciones" className="text-blue-700 underline hover:text-blue-900">{phrase}</a>
        {text.slice(idx + phrase.length)}
      </>
    );
  }, [news, currentIndex]);

  if (!news || news.length === 0) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto m-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-2xl font-bold mb-2 text-blue-800">{news[currentIndex].title}
          {news[currentIndex].isNew && (
            <span className="ml-2 px-2 py-1 text-xs font-semibold rounded-full bg-red-500 text-white animate-blink-soft">
              Nueva
            </span>
          )}
        </h2>
        <p className="text-sm text-gray-500 mb-4">{news[currentIndex].date}</p>
        <div className="flex flex-col md:flex-row gap-4">
          {news[currentIndex].image && (
            <img
              src={news[currentIndex].image}
              alt={news[currentIndex].title}
              className="w-full md:w-48 h-48 object-cover rounded"
            />
          )}
          <div className="flex-1">
            <p className="text-black whitespace-pre-wrap">{linkedContent}</p>
          </div>
        </div>
        <div className="flex justify-between mt-6">
          <button
            onClick={handlePrev}
            className="text-gray-600 hover:text-gray-900 transition-colors px-4 py-2 rounded-md hover:bg-gray-100"
          >
            ← Anterior
          </button>
          <button
            onClick={handleNext}
            className="text-gray-600 hover:text-gray-900 transition-colors px-4 py-2 rounded-md hover:bg-gray-100"
          >
            Siguiente →
          </button>
        </div>
        <Button
          variant="default"
          className="w-full mt-4"
          onClick={onClose}
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
}
